import { useQuery } from "@tanstack/react-query";
import { Seo } from "@/components/Seo";
import { JsonLd, breadcrumbSchema } from "@/components/StructuredData";
import { Icon } from "@/components/Icon";
import { KbArticles } from "@/components/KbArticles";
import { fetchKbArticles } from "@/lib/kb-articles";
import { useContactEmail } from "@/lib/use-app-config";

const TITLE = "Informații utile — Asistent Auto";
const DESCRIPTION =
  "Articole despre RCA, daune și acte auto — sincronizate live din aplicație. Le actualizăm când se schimbă piața sau apare o lege nouă.";

export default function AjutorPage() {
  const { data: articles = [] } = useQuery({
    queryKey: ["kb-articles"],
    queryFn: fetchKbArticles,
    staleTime: 5 * 60 * 1000,
  });
  const contactEmail = useContactEmail();

  return (
    <>
      <Seo title={TITLE} description={DESCRIPTION} path="/ajutor" />
      <JsonLd
        data={breadcrumbSchema([
          { name: "Acasă", path: "/" },
          { name: "Informații utile", path: "/ajutor" },
        ])}
      />
      <header className="page-hero">
        <div className="shell">
          <div className="section-eyebrow">Informații utile</div>
          <h1>
            Articolele pe care le citești și<br />
            <em>în aplicație.</em>
          </h1>
          <p>
            Aceleași texte despre RCA, daune și acte auto. Le actualizăm când
            ASF publică ceva, când un asigurător se schimbă, sau când apare o
            lege nouă.
          </p>
        </div>
      </header>

      <section className="section section--tight">
        <div className="shell">
          <div className="kb-header">
            <div>
              <div className="section-eyebrow">Toate articolele</div>
              <h2>
                Răspunsuri scurte, <em>actualizate live.</em>
              </h2>
            </div>
            <span className="kb-live">
              <span className="dot" />
              SINCRONIZAT LIVE · {articles.length} ARTICOLE
            </span>
          </div>

          <KbArticles articles={articles} />

          <div className="kb-article-cta">
            <div>
              <h3>Ai o întrebare specifică?</h3>
              <p>
                Sună sau scrie-ne — răspundem în aceeași zi în zilele
                lucrătoare.
              </p>
            </div>
            <a
              href={`mailto:${contactEmail}`}
              className="btn btn--primary"
            >
              <Icon name="mail" />
              Scrie-ne pe email
            </a>
          </div>
        </div>
      </section>
    </>
  );
}
